interface EmptyStateProps {
  icon?: string;
  title?: string;
  description?: string;
}

export function EmptyState({
  icon = 'ri-inbox-line',
  title = 'Chưa có dữ liệu',
  description = 'Danh sách hiện đang trống. Hãy thêm mới để bắt đầu.',
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="w-14 h-14 flex items-center justify-center rounded-full bg-slate-100 mb-4">
        <i className={`${icon} text-2xl text-slate-400`} />
      </div>
      <h3 className="text-base font-medium text-slate-700 mb-1">{title}</h3>
      <p className="text-sm text-slate-400 max-w-xs">{description}</p>
    </div>
  );
}